import { Component, OnInit } from '@angular/core';
import { MissionDetailsComponent } from '../agency-etab-missions-details/encour-component/mission-details/mission-details.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { MissionService } from '../../../services/mission.service';
import { FormBuilder } from '@angular/forms';
import { Mission } from '../../../models/Mission';
import { MissionCandidateTableActionsComponent } from '../agency-etab-missions-details/encour-component/components/mission-candidate-table-actions/mission-candidate-table-actions.component';
import { TableEnCourActionComponent } from '../agency-etab-missions-details/encour-component/components/table-en-cour-action/table-en-cour-action.component';
import { ReferenceTitleComponent } from '../agency-etab-missions-details/reference-title/reference-title.component';
import { DataColumn } from '../../../models';
import { UserComponent } from '../../../shared/user/user.component';
import moment from 'moment';
import { MissionTableActionsComponent } from '../agency-etab-missions-details/encour-component/components/mission-table-actions/mission-table-actions.component';

@Component({
  selector: 'app-missions-management',
  templateUrl: './missions-management.component.html',
  styleUrl: './missions-management.component.scss'
})
export class MissionsManagementComponent implements OnInit {
  component: any[] = [UserComponent];
  isLoading: boolean = false;
  customColumns: DataColumn[] = [
    {
      header: 'Référence',
      fieldName: 'missionTitle',
      component: ReferenceTitleComponent,
      dataType: 'component',
      col: 'col',
    },
    {
      header: 'Etablissement',
      fieldName: 'etablissementNom',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Département',
      fieldName: 'regionCode',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Service d’affectation',
      fieldName: 'serviceAffectationsName',
      dataType: 'string',
      col: 'col',
    },
    {header: 'Poste', fieldName: 'typePoste', dataType: 'string', col: 'col',},
    {
      header: 'Type de contrat',
      fieldName: 'typecontat',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Dates',
      fieldName: 'duration',
      fieldNameStartDate: 'startdate',
      fieldNameEndDate: 'enddate',
      dataType: 'date',
      col: 'col',
    },
    {
      header: 'Rémunération',
      fieldName: 'compensationproposednet',
      fieldNameCurrency: 'currency',
      dataType: 'currency',
      col: 'col',
    },
    {
      header: 'Statut',
      fieldName: '',
      component: TableEnCourActionComponent,
      dataType: 'component',
      col: 'col',
      unClickable: true,
    },
    {
      header: 'Actions',
      fieldName: '',
      component: MissionTableActionsComponent,
      dataType: 'component',
      col: 'col',
      unClickable: true,
    },
  ];
  id: number;
  missionListFiltered: Mission[] = [];
  offset = 0;
  size = 10;
  totalItems = 0;
  private typePosteId: any;
  selectedSite: null= null;
  siteList: any[] = []
  inputSearch: string = '';

  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private api: MissionService,
    private fb: FormBuilder
  ) {
    this.id = 1;
    this.typePosteId = 13;
  }

  ngOnInit(): void {
    this.loadMissions();  
  }

  private loadMissions(): void {
    this.isLoading = true;
    this.api
      .getLiberalCurrentMissionsWithPagination(this.offset, this.size, this.inputSearch, this.selectedSite || 0)
      .subscribe({
        next: (res: any) => {
          this.missionListFiltered = res.missions.map((mission: any) => {
            if (mission.typecontat == 'LIBERAL') {
              mission.typecontat = 'Intérim'
            }
            mission.site = mission?.adresseDto?.name ?? '';
            mission.regionCode = mission?.regionCode ?? '';
            mission.isUrgent = mission?.isurgent;
            return mission
          });
          this.totalItems = res.totalItems;
        
          // Use siteList from backend response
          if (res.siteList && res.siteList.length > 0) {
            this.siteList = res.siteList;
          }
        },
        error: () => {
          this.missionListFiltered = [];
          this.totalItems = 0;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }
  handleRowClick = (row: any) => {
    const dialog = this.dialog.open(MissionDetailsComponent, {
      width: '666px',
      height: '100vh',
      position: {right: '0'},
      backdropClass: 'bg-transparent',
      data: row,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        this.loadMissions();
      }
    });
  };


  pagination(event: any) {
    this.size = event.pageSize;
    this.offset = event.pageIndex * this.size;
    this.loadMissions();
  }

  searchItem(event: any) {
    if(!!event) {
      this.inputSearch = event.target.value.trim().toLowerCase();
      this.offset = 0; // Reset to first page on search
      this.loadMissions();
    }
  }

  toggleSelectSite(event: any, item: any) {
    if (event) {
      this.selectedSite = item.id;
    } else {
      this.selectedSite = null;
    }
    this.offset = 0; // Reset to first page on filter change
    this.loadMissions();
  }
}